'use client';

import React from 'react';
import styles from './GlobalCardRadioButton.module.css';

import { useTheme } from '../context/ThemeProvider';

type GlobalCardRadioButtonProps = {
  icon: React.ReactNode;
  headline: string;
  paragraph: string;
  ctaLabel: string;
  ctaIcon: React.ReactNode;
  name: string;
  value: string;
  isSelected: boolean;
  statusText?: string;
  statusPositive?: boolean;
  onSelect: (value: string) => void;
  ctaDestructive?: boolean;
  ctaIconLeft?: boolean;
};

const GlobalCardRadioButton: React.FC<GlobalCardRadioButtonProps> = ({
  icon,
  headline,
  paragraph,
  ctaLabel,
  ctaIcon,
  name,
  value,
  isSelected,
  statusText,
  statusPositive,
  onSelect,
  ctaDestructive,
  ctaIconLeft,
}) => {
  const handleChange = () => {
    onSelect(value);
  };

  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  return (
    <label className={`${styles.card} ${isSelected ? styles.selected : ''}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={isSelected}
        onChange={handleChange}
        className={styles.input}
      />
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.headline}>{headline}</h3>
      <p className={styles.paragraph}>{paragraph}</p>
      {statusPositive !== undefined && statusPositive !== null && (
        <div className={styles.statusWrapper}>
          <img
            src={
              statusPositive
                ? '/assets/icons/checkmark.circle.fill.green.svg'
                : '/assets/icons/exclamationmark.square.fill.red.svg'
            }
            alt={statusPositive ? 'On' : 'Off'}
            className={`${styles.statusIcon} ${
              statusPositive && !isDarkMode ? styles.darkenGreenIcon : ''
            }`}
            width={16}
            height={16}
          />
          <span className={`${styles.status} ${statusPositive ? styles.statusPositive : ''}`}>{statusText}</span>
        </div>
      )}
      <div className={`${styles.cta} ${ctaDestructive ? styles.destructive : ''}`}>
        {ctaIconLeft && ctaIcon}
        <span>{ctaLabel}</span>
        {!ctaIconLeft && ctaIcon}
      </div>

      {/* Selected badge */}
      <div className={styles.selectedBadge}>
        Selected
      </div>
    </label>
  );
};

export default GlobalCardRadioButton;
